export default "__VITE_ASSET__Cdl55pPu__"